import React from "react";
import { useRoutePath } from "../../../../../util/Routing";
import { EntityListPage } from "../shared/EntityListPage";

export function CustomersListPage(): JSX.Element {
  const { adminPath } = useRoutePath();
  return (
    <EntityListPage
      entityType="customer"
      detailBasePath={`${adminPath}/mdm/customers`}
    />
  );
}
